
export function safeArraySum(arr: number[]): number {
  return arr.filter(val => typeof val === 'number' && !isNaN(val)).reduce((sum, val) => sum + val, 0);
}

export function generateWorstCaseScenario(baseScenario: number[]): number[] {
  return baseScenario.map(value => value * 0.6); // 40% reduction for worst case
}

export function calculateScenarioValues(scenarios: any) {
  const realisticScenarioValue = safeArraySum(scenarios.realistic);
  const pessimisticScenarioValue = safeArraySum(scenarios.pessimistic);
  const optimisticScenarioValue = safeArraySum(scenarios.optimistic);
  
  const worstCaseScenario = generateWorstCaseScenario(scenarios.pessimistic);
  const worstCaseScenarioValue = safeArraySum(worstCaseScenario);

  return {
    realisticScenarioValue,
    pessimisticScenarioValue,
    optimisticScenarioValue,
    worstCaseScenario,
    worstCaseScenarioValue
  };
}

export function calculateAverageProbabilityOfSuccess(phaseAnalyses: Record<string, any>): number {
  const phaseSuccessValues = Object.values(phaseAnalyses)
    .map((phase: any) => typeof phase.probabilityOfSuccess === 'number' ? phase.probabilityOfSuccess : 0)
    .filter(val => !isNaN(val));
  
  return phaseSuccessValues.length > 0 
    ? phaseSuccessValues.reduce((sum, val) => sum + val, 0) / phaseSuccessValues.length 
    : 0.5;
}
